import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const MemberLabsAuthorizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberLabsAuthorization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"MemberLabsAuthorization","document":MemberLabsAuthorizationDocument}} as const;
export type MemberLabsAuthorizationQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID']['input'];
}>;


export type MemberLabsAuthorizationQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'username'>
  )> }
);

/**
 * __useMemberLabsAuthorizationQuery__
 *
 * To run a query within a React component, call `useMemberLabsAuthorizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberLabsAuthorizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberLabsAuthorizationQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useMemberLabsAuthorizationQuery(
  baseOptions: TrelloQueryHookOptions<
    MemberLabsAuthorizationQuery,
    MemberLabsAuthorizationQueryVariables
  > &
    (
      | { variables: MemberLabsAuthorizationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: MemberLabsAuthorizationDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    MemberLabsAuthorizationQuery,
    MemberLabsAuthorizationQueryVariables
  >(MemberLabsAuthorizationDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useMemberLabsAuthorizationLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    MemberLabsAuthorizationQuery,
    MemberLabsAuthorizationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MemberLabsAuthorizationQuery,
    MemberLabsAuthorizationQueryVariables
  >(MemberLabsAuthorizationDocument, options);
}
export function useMemberLabsAuthorizationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        MemberLabsAuthorizationQuery,
        MemberLabsAuthorizationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MemberLabsAuthorizationQuery,
    MemberLabsAuthorizationQueryVariables
  >(MemberLabsAuthorizationDocument, options);
}
export type MemberLabsAuthorizationQueryHookResult = ReturnType<
  typeof useMemberLabsAuthorizationQuery
>;
export type MemberLabsAuthorizationLazyQueryHookResult = ReturnType<
  typeof useMemberLabsAuthorizationLazyQuery
>;
export type MemberLabsAuthorizationSuspenseQueryHookResult = ReturnType<
  typeof useMemberLabsAuthorizationSuspenseQuery
>;
export type MemberLabsAuthorizationQueryResult = Apollo.QueryResult<
  MemberLabsAuthorizationQuery,
  MemberLabsAuthorizationQueryVariables
>;
